import axios from 'axios'

const shopId = process.env.SHOP_ID || '1360134207'

export type CustomerError = {
  code:
    | 'CUSTOMER_DOES_NOT_EXIST'
    | 'INVALID'
    | 'CUSTOMER_INPUT+ARGUMENT_EMPTY'
    | 'TOO_LONG'
}

export type CustomerAddressError = {
  code:
    | 'ADDRESS1_MISSING'
    | 'ADDRESS_ARGUMENT_EMPTY'
    | 'ADDRESS_ID_DOES_NOT_EXIST'
    | 'COUNTRY_NOT_EXIST'
    | 'CUSTOMER_ADDRESS_ALREADY_EXISTS'
    | 'DELETING_CUSTOMER_DEFAULT_ADDRESS_NOT_ALLOWED'
    | 'INVALID'
    | 'INVALID_FOR_COUNTRY'
    | 'INVALID_FOR_COUNTRY_AND_PROVINCE'
    | 'INVALID_TERRITORY_CODE'
    | 'PHONE_NUMBER_NOT_VALID'
    | 'REQUIRED'
    | 'TERRITORY_CODE_MISSING'
    | 'TOO_LONG'
    | 'ZONE_CODE_MISSING'
  field: string
  message: string
}

type ReturnType<T> = {
  data: T
  errors?: CustomerAddressError[]
}

export async function makeCustomerRequest<T>(
  query: string,
  variables: Record<string, unknown> = {},
  token: string
): Promise<ReturnType<T>> {
  const { data } = await axios({
    method: 'post',
    url: `https://shopify.com/${shopId}/account/customer/api/2025-04/graphql`,
    headers: {
      Authorization: token,
      'Content-Type': 'application/json'
    },
    data: {
      query,
      variables
    }
  })
  return data
}
